import React, { useEffect, useState } from 'react';
import Main from '../../Main';
import { Col, Dropdown, Row } from 'react-bootstrap';
import columnFilter from '../../../assets/images/CustomerManagement/columnFilter.svg'
import valueFilter from '../../../assets/images/CustomerManagement/valueFilter.svg'
import '../../../assets/css/dashboard.scss'
import '../../../assets/css/customermanagement.scss'
import 'react-datepicker/dist/react-datepicker.css';
import SbCancelBtn, { SbAddBtn, SbFilterBtn } from '../../Buttons/Buttons';
import Select from 'react-select';
import DepartmentTable from './DepartmentTable';
import AddDepartment from './AddDepartment';
import Download from '../../MainSection/Download/Download';
import { useNavigate, useParams } from 'react-router-dom';
import DepartmentValueFilterModal from './DepartmentValueFilterModal';
import DepartmentColumnFilterModal from './DepartmentColumnFilterModal';
import { loadDepartmentData, loadSingleDepartmentData, postDepartmentDatas } from '../../../redux/action';
import { useDispatch, useSelector } from 'react-redux';
import * as HeaderAuthentication from '../../HeaderAuthentication'
import { ADDED_BY_ID } from '../../../Constants';
import DeparmentBulkUploadModal from './DeparmentBulkUploadModal';
import SbDropdownButton from '../../Buttons/SbDropdownButton';

const statusOptions = [
    { value: 3, label: "Active" },
    { value: 4, label: "Inactive" }
]

const Department = () => {

    let dispatch = useDispatch();
    const { id: userRefId } = useParams();

    const { departmentData } = useSelector((state) => state.data);
    const { singleDepartmentData } = useSelector((state) => state.data);
    const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));
    const PreviousCompanyID = JSON.parse(sessionStorage.getItem('PreviousCompanyID'));

    const [loading, setLoading] = useState(true);

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [showFilterMenu, setShowFilterMenu] = useState(false);
    const [showColumnFilterModal, setShowColumnFilterModal] = useState(false);
    const [showValueFilterModal, setShowValueFilterModal] = useState(false);
    const [showCustomerViewDetails, setShowCustomerViewDetails] = useState(false);
    const [businessUnitModal, setBusinessUnitModal] = useState(false);
    const [branchPlantModal, setBranchPlantModal] = useState(false);
    const [deptId, setDeptId] = useState("");
    const [depName, setDepName] = useState("");
    const [selectedColumns, setSelectedColumns] = useState([
        "DEPARTMENT", "COMPANY NAME", "STATUS", "ACTION"
    ]);
    const [selectedStatusID, setSelectedStatusID] = useState(null);
    const [showBulkUploadModal, setShowBulkUploadModal] = useState(false);
    const [dataLoading, setDataLoading] = useState(false);

    useEffect(() => {
        if (userRefId) {
            dispatch(loadSingleDepartmentData(userRefId, setDataLoading));
        } else {
            deptData();
        }
    }, [userRefId]);

    const deptData = (statusID) => {
        dispatch(loadDepartmentData(setLoading, statusID));
    }

    useEffect(() => {
        deptData();
    }, []);

    const handleStatusSelection = (selectedOption) => {
        if (selectedOption) {
            const statusID = selectedOption.value;  // Extract StatusID (assuming 'value' is the StatusID)
            setSelectedStatusID(statusID);  // Store StatusID in state
            deptData(statusID);  // Call API with both StatusID and current RoleID
        }
    };

    const toggleFilterMenu = () => {
        setShowFilterMenu(!showFilterMenu);
    };

    const handleOpenModal = (depID) => {
        setIsModalOpen(true);
        if (depID) {
            dispatch(loadSingleDepartmentData(depID, setDataLoading));
            setDeptId(depID);
        } else {
            setDeptId("");
        }
    };

    const handleCloseModal = () => {
        setDeptId("");
        dispatch(loadSingleDepartmentData(null, setDataLoading));
        setIsModalOpen(false);
    };
    const handleOpenBulkUploadModal = () => {
        setShowBulkUploadModal(true);
    };
    const handleCloseBulkUploadModal = () => {
        setShowBulkUploadModal(false);
    };

    const handleStatusChange = (customer, statusLabel) => {
        const statusID = statusLabel === "Active" ? 3 : 4; // 3 for Active, 4 for Inactive
        // console.log(`Determined StatusID: ${statusID}`);

        // const depName = singleDepartmentData[0]?.DepartmentName
        console.log(customer, 'customer')
        const data = {
            DeptID: customer.DeptID,
            StatusID: statusID,
            DepartmentName: customer.DepartmentName,
            AddedByID: ADDED_BY_ID,
        };

        // console.log(data, 'data');
        console.log(singleDepartmentData, 'singleDepartmentData[0]?.DepartmentName');
        let requestOption = {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify(data),
        };

        // Dispatch the action to update the department status
        dispatch(postDepartmentDatas(requestOption, handleCloseModal, deptData, customer.DeptID));
        // console.log(data, 'data'); // For debugging purposes
    };

    const handleOpenColumnFilterModal = () => {
        setShowFilterMenu(false);
        setShowColumnFilterModal(true);
    };

    const handleCloseColumnFilterModal = () => {
        setShowColumnFilterModal(false);
    };
    const handleOpenValueFilterModal = () => {
        setShowFilterMenu(false);
        setShowValueFilterModal(true);
    };

    const handleCloseValueFilterModal = () => {
        setShowValueFilterModal(false);
    };

    const handleViewDetails = () => {
        setShowCustomerViewDetails(!showCustomerViewDetails);
    }

    const handleColumnSelectionChange = (updatedSelectedColumns) => {
        setSelectedColumns(updatedSelectedColumns); // Update the selected columns
    };

    const navigate = useNavigate();
    const handleBack = () => {
        navigate(-1);
    };

    const handleClearFilters = () => {
        setSelectedStatusID(null);
        deptData();
    }

    return (
        <div className="customer-management-container">
            <Main>
                <div className='components-download-container'>
                    <Download
                        showBackButton={true}
                        moduleName="Settings / Department"
                        onBackClick={handleBack}
                    />
                </div>
                <div className='customermanagement-content-container'>
                    <div className="customermanagement-content">
                        <Row className='customermanagement-btns-container'>
                            <Col md={3} className='customermanagement-backbtn-div'>
                                {/* <img src={backbtn} alt="" /> */}
                                <span>Department</span>
                            </Col>
                            <Col md={9} className='customermanagement-search-filter'>
                                <div className='customermanagement-header-btns filter-btn'>
                                    <SbFilterBtn btnName="Filters" onClickEffect={toggleFilterMenu} />
                                    {showFilterMenu && (
                                        <Dropdown.Menu show className='filter-dropdown-options'>
                                            <Dropdown.Item onClick={handleOpenColumnFilterModal}>
                                                <img src={columnFilter} alt="" />&nbsp;&nbsp;
                                                Column Filter
                                            </Dropdown.Item>
                                            <Dropdown.Item onClick={handleOpenValueFilterModal}>
                                                <img src={valueFilter} alt="" />&nbsp;&nbsp;
                                                Value Filter
                                            </Dropdown.Item>
                                        </Dropdown.Menu>
                                    )}
                                </div>
                                <Col md={3} className='filters-col'>
                                    <Select
                                        className="react-select-container complaint-status-select"
                                        classNamePrefix="react-select"
                                        placeholder="Search Status"
                                        options={statusOptions}
                                        style={{ width: "100%" }}
                                        value={selectedStatusID ? statusOptions.find(status => status.value === selectedStatusID) : null}
                                        onChange={(selectedOption) => handleStatusSelection(selectedOption)}
                                    />
                                </Col>
                                <SbCancelBtn btnName="Clear" onClickEffect={handleClearFilters} />
                                {(signInDetails[0]?.SignInType !== 'ClientAdmin' || PreviousCompanyID) && <SbDropdownButton
                                    btnName="Add"
                                    openAddModal={() => { handleOpenModal("") }}
                                    addBulkModel={handleOpenBulkUploadModal}
                                />}
                            </Col>
                        </Row>
                        <div className='customermanagement-table-div'>
                            <DepartmentTable
                                handleOpenModal={handleOpenModal}
                                handleViewDetails={handleViewDetails}
                                departmentData={departmentData}
                                loading={loading}
                                handleStatusChange={handleStatusChange}
                                selectedColumns={selectedColumns}
                                signInDetails={signInDetails}
                                PreviousCompanyID={PreviousCompanyID}
                                singleDepartmentData={singleDepartmentData}
                                userRefId={userRefId}
                            />
                        </div>
                    </div>
                </div>
            </Main>
            {
                isModalOpen && <AddDepartment
                    open={isModalOpen}
                    handleCloseModal={handleCloseModal}
                    deptData={deptData}
                    deptId={deptId}
                    singleDepartmentData={singleDepartmentData}
                    dataLoading={dataLoading}
                />
            }
            {
                showBulkUploadModal && <DeparmentBulkUploadModal
                    showBulkUploadModal={showBulkUploadModal}
                    handleCloseBulkUploadModal={handleCloseBulkUploadModal}
                    deptData={deptData}
                />
            }
            {showColumnFilterModal && (
                <DepartmentColumnFilterModal
                    showColumnFilterModal={showColumnFilterModal}
                    handleCloseColumnFilterModal={handleCloseColumnFilterModal}
                    selectedColumns={selectedColumns}
                    handleSaveColumns={handleColumnSelectionChange}
                />
            )}
            {showValueFilterModal && (
                <DepartmentValueFilterModal
                    showValueFilterModal={showValueFilterModal}
                    handleCloseValueFilterModal={handleCloseValueFilterModal}
                />
            )}
            {/* {showCustomerViewDetails && (
                <CustomerViewDetails
                    showCustomerViewDetails={showCustomerViewDetails}
                    handleCloseViewDetails={handleCloseViewDetails}
                />
            )} */}
        </div >
    );
};

export default Department;